import { LOCALE_MAP, SupportedLocale } from "./locales";

/**
 * Normalise un code langue pour toujours renvoyer un SupportedLocale
 */
function normalizeLanguage(code: string | undefined): SupportedLocale {
    if (!code) return "fr-FR";

    const lower = code.toLowerCase();

    // 1. Cherche direct dans LOCALE_MAP
    if (LOCALE_MAP[lower]) {
        return LOCALE_MAP[lower];
    }

    // 2. Si déjà un SupportedLocale exact
    if ((Object.values(LOCALE_MAP) as string[]).includes(lower)) {
        return lower as SupportedLocale;
    }

    // 3. Fallback
    console.warn(`[i18n] Langue inconnue détectée: "${code}", fallback en fr-FR`);
    return "fr-FR";
}

/**
 * Détecte la langue à partir d’un hostname.
 * - Production: fr.bazarchic.com
 * - Préprod: bzcfront-111-front-fr.pp.bazarchic.com
 * - Localhost: fr.localhost
 */
export async function detectLanguage(
    hostname: string = window.location.hostname
): Promise<SupportedLocale> {
    const lowerHost = hostname.toLowerCase();

    // Cas 1 : sous-domaine direct (fr.localhost, fr.bazarchic.com)
    const subdomain = lowerHost.split(".")[0];
    if (LOCALE_MAP[subdomain]) {
        return normalizeLanguage(subdomain);
    }

    // Cas 2 : préprod (bzcfront-111-front-fr.pp.bazarchic.com)
    const match = lowerHost.match(/-([a-z]{2}(?:-[a-z]{2})?)\./i);
    if (match) {
        return normalizeLanguage(match[1]);
    }

    // Cas 3 : fallback propre
    return "fr-FR";
}
